import * as React from "react";
import {Link} from "react-router-dom";
import {map} from "lodash";
import {Field, FieldArray, reduxForm} from "redux-form";
import {connect} from "react-redux";
import Card from '@material-ui/core/Card';
import Select from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import renderField from "../onboarding/Form";
import './styles.scss'
const required = value => value ? undefined : "Required";
const styles ={
  flex: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  input: {
    width: '48%',
    marginBottom: 40
  },
  pointOfContact: {
    padding: 40,
    backgroundColor: '#f3f3f3'
  },
  contactInput: {
    width: '32%'
  }
}
const renderSelectField = ({
  input,
  children,
  ...custom
}) => (
    <Select {...input} children={children} {...custom} className="input-border" />
);


const CharityFormComponent: React.SFC<any> = (props: any) => {
  const {
    pristine,
    stripeAccounts,
    submitting,
    handleSubmit,
    classes,
    auth,
    paypalAccounts
  } = props;
  return (
    <Card>
      <CardContent>
    <form onSubmit={handleSubmit}>
      <div className={classes.flex}>
        <div className={classes.input}>
          <Field
            component={renderField}
            type="text"
            label="Charity Name"
            name="name"
            validate={[required]}
          />
        </div>
        <div className={classes.input}>
          <Field
            component={renderField}
            type="number"
            label="Charity Id"
            name="charityId"
          />
        </div>
      </div>
        <Field
          component={renderField}
          type="textarea"
          label="Description"
          name="description"
          style={{marginBottom: 40}}
        />
      <div className={classes.flex}>
        <div className={classes.input}>
          <Field
            placeholder="Email"
            label="Email"
            name="email"
            type="email"
            component={renderField}
          />
        </div>
        <div className={classes.input}>
          <Field
            placeholder="Charity URL"
            label="Charity URL"
            name="charityUrl"
            type="text"
            component={renderField}
          />
        </div>
      </div>
      <div className={classes.flex}>
        <div className={classes.input}>
          <Field
            placeholder="Facebook Link"
            label="Facebook Link"
            name="facebook"
            type="text"
            component={renderField}
          />
        </div>
        <div className={classes.input}>
          <Field
            placeholder="Twitter Link"
            label="Twitter Link"
            name="twitter"
            type="text"
            component={renderField}
          />
        </div>
      </div>
      <div className={classes.flex}>
      {
        (!!stripeAccounts && auth.isAdmin) &&
        <div className={classes.input}>
          <InputLabel>Stripe Connected Account</InputLabel>
          <div className="control">
            <Field name="stripeAccount" component={renderSelectField} className={classes.input}>
              <option value="">None</option>
              {map(stripeAccounts, (acc: any, key: string) => (
                <option key={key} value={acc.stripeUserId}>{`${acc.displayName} / ${acc.email}`}</option>
              ))}
            </Field>
          </div>
        </div>
      }
      {
        (!!paypalAccounts && auth.isAdmin) &&
        <div className={classes.input}>
          <InputLabel>Paypal Connected Account</InputLabel>
          <div className="control">
            <Field name="paypalAccount" component={renderSelectField} className={classes.input}>
              <option value="">None</option>
              {map(paypalAccounts, (paypalUser: any, key: string) => (
                <option key={key} value={key}>{`${paypalUser.email} / ${paypalUser.merchant_id}`}</option>
              ))}
            </Field>
          </div>
        </div>
      }
      </div>
      <div className={classes.pointOfContact}>
        <Typography variant="body2">Point of contact</Typography>
        <div style={{display: 'flex', justifyContent:'space-between'}}>
          <Field
            placeholder="Name"
            label="Name"
            name="userName"
            type="text"
            component={renderField}
            className={classes.contactInput}
          />
          <Field
            placeholder="Role"
            label="Role"
            name="role"
            type="text"
            component={renderField}
            className={classes.contactInput}
          />
          <Field
            placeholder="Phone Number"
            label="Phone Number"
            name="phoneNumber"
            type="text"
            component={renderField}
            className={classes.contactInput}
          />
        </div>
      </div>
      <hr/>
      <div className="field is-grouped">
        <div className="control">
          <Link  to="/charities">
            <Button variant="outlined">
              Back to charities
            </Button>
          </Link>
        </div>
        <div className="control">
          <Button
            type="submit"
            disabled={pristine || submitting}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </div>
      </div>
    </form>
    </CardContent>
    </Card>
  );
};

const CharityFormWithForm: any = reduxForm({
  form: "charity", // a unique identifier for this form
})(CharityFormComponent);

const mapStateToProps: any = ({charities, auth}) => {
  if (charities && charities.currentlyEditingCharity) {
    const {sidePanel} = charities.currentlyEditingCharity;
    let sidePanelFacts = [];
    let sidePanelFooter = '';

    if (sidePanel) {
      const {facts, footer} = sidePanel;
      sidePanelFacts = map(facts, (fact) => ({...fact}));
      sidePanelFooter = footer;
    }

    const initialValues = {
      ...charities.currentlyEditingCharity,
      sidePanelFacts,
      sidePanelFooter
    };
    return {
      initialValues,
      auth
    };
  } else {
    return { auth };
  }
};


export const CharityForm = connect(mapStateToProps)(withStyles(styles)(CharityFormWithForm)) as any;
